/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
export default {


  sysManagement: { SC: "系统管理", TC: "系統管理", EN: "System" }
  , update: { SC: "修改", TC: "修改", EN: "Edit" }
  , delete: { SC: "删除", TC: "刪除", EN: "Delete" }
  , audit: { SC: "日志", TC: "日誌", EN: "Log" }
  , selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
  , deleteData: { SC: "数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
  , deleteSuccess: { SC: "删除成功", TC: "刪除成功", EN: "Deleted successfully." }
  , beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." }
  , noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
  , saveSuccess: { SC: "保存成功", TC: "保存成功", EN: "Saved successfully." }
  , controls: { SC: "操作", TC: "操作", EN: "Operation" }
  , list: { SC: "列表", TC: "列表", EN: "List" }
  , search: { SC: "查询", TC: "査詢", EN: "Search" }
  , reset: { SC: "重置", TC: "重置", EN: "Reset" }
  , add: { SC: "新增", TC: "新增", EN: "Add" }
  , save: { SC: "保存", TC: "保存", EN: "Save" }
  , cancel: { SC: "取消", TC: "取消", EN: "Cancel" }
  , dataBeSaving: { SC: "数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }

  , startDateNoIsNull: { SC: "开始日期不能为空", TC: "開始日期不能為空", EN: "State Time is required." }
  , startDateMax: { SC: "开始日期不能晚于结束日期", TC: "開始日期不能晚於結束日期", EN: "The start date cannot be later than the end date." }
  , endDateNoIsNull: { SC: "结束日期不能为空", TC: "結束日期不能為空", EN: "End Time is required." }
  , endDateMin: { SC: "结束日期不能早于开始日期", TC: "結束日期不能早於開始日期", EN: "The end date cannot be earlier than the start date." }
  , sysManage: { SC: "系统管理", TC: "系統管理", EN: "System" }

  , apiName: { SC: "API名字", TC: "API名字", EN: "API Name" }
  , userIp: { SC: "客户端IP", TC: "用戶端IP", EN: "User IP" }
  , head: { SC: "请求HTTP标头", TC: "請求HTTP標頭", EN: "HTTP Header" }
  , status: { SC: "结果", TC: "結果", EN: "Status" }
  , content: { SC: "内容", TC: "內容", EN: "Response" }
  , inputParameters: { SC: "请求参数", TC: "請求參數", EN: "Input Parameters" }
  , startTime: { SC: "开始时间", TC: "開始時間", EN: "Start Time" }
  , endTime: { SC: "结束时间", TC: "結束時間", EN: "End Time" }
  , elapsedTime: { SC: "请求用时", TC: "請求用時", EN: "Elapsed Time" }
  , user: { SC: "用户", TC: "用戶", EN: "User" }
  , mode: { SC: "模式", TC: "模式", EN: "Mode" }
  , log: { SC: "API日志记录", TC: "API日誌記錄", EN: "API Log" }
  , operationType: { SC: "操作类型", TC: "操作類型", EN: "Operation Type" }

  , userCode: { SC: "账号", TC: "帳號", EN: "Account" }
  , userName: { SC: "姓名", TC: "姓名", EN: "Name" }
  , funcName: { SC: "模块名称", TC: "模塊名稱", EN: "Function Name" }

  , operationContent: { SC: "操作內容", TC: "操作內容", EN: "Operation Content" }
  , operationTime: { SC: "操作时间", TC: "操作時間", EN: "Operation Time" }
  , loginIpAddress: { SC: "登录IP地址", TC: "登錄IP地址", EN: "Login IP Address" }
  , search2: { SC: "查找中...", TC: "查找中…", EN: "Searching..." }
  , zhi: { SC: "至", TC: "至", EN: "to" }

}